// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_33-1";
export var movingGradient = "_33-4";
export var movingGradientBlock = "_33-2";
export var skeleton = "_33-0";
export var skeletonText = "_33-3";